import React, { useEffect, useState } from "react";
import ReactSpeedometer from "react-d3-speedometer";

const styles = {
  dial: {
    display: "inline-block",
    width: `300px`,
    height: `auto`,
    color: "#000",
    border: "0.5px solid #fff",
    padding: "2px",
  },
  title: {
    fontSize: "1em",
    color: "#000",
  },
};

const Speedometer = ({ id, value, title }) => {
  const [minValue, setMinValue] = useState(0); // Start at zero
  const [maxValue, setMaxValue] = useState(100); // Default max value to start from 100
  const segments = 10; // Number of segments/labels

  useEffect(() => {
    if (value >= 0) {
      // Determine the nearest multiple of 100 below the value (this will be the minValue)
      const base = Math.floor(value / 100) * 100;

      // Set the minimum value
      setMinValue(base);

      // Set the maximum value to the next multiple of 100 above the value
      const nextSegment = base + 100;
      setMaxValue(nextSegment);
    }
  }, [value]);

  useEffect(() => {
    // Adjust font size dynamically for segment values
    const segmentValues = document.querySelectorAll(".segment-value");
    segmentValues.forEach((element) => {
      const textContent = element.textContent;
      if (textContent.length > 4) {
        element.style.fontSize = "9px";
      } else {
        element.style.fontSize = "14px";
      }
    });
  }, [maxValue]);

  console.log("Current Value:", value);
  console.log(minValue, "Calculated Max Value:", maxValue);

  return (
    <div style={{ textAlign: "center", margin: "20px" }}>
      <h3>{title}</h3>
      <div style={{ display: "inline-block" }}>
        <ReactSpeedometer
          key={maxValue} // Force re-render when maxValue changes
          maxValue={maxValue}
          minValue={minValue}
          value={value}
          segments={segments}
          needleTransition="easeQuadIn"
          needleTransitionDuration={1000}
          needleColor="red"
          // startColor="green"
          // endColor="blue"
          segmentColors={[
            "#44a0f5",
            // "green",
            // "green",
            // "green",
            // "green",
            // "green",
            // "green",
            // "yellow",
            // "yellow",
            // "red",
          ]} // 3 colors applied to 10 segments
          currentValueText={`${value}`}
          height={190}
          width={290}
        />
      </div>
    </div>
  );
};

export default Speedometer;
